import { ZHLPersonalizedNextStepState } from 'src/services/graphql/generated/graphql';
import { APPLICATION_LIFECYCLE_STATUS_TO_IMAGES, ApplicationLifecycleStatus } from './constants';

export const isValidApplicationLifecycleStatus = (
    status: ZHLPersonalizedNextStepState | null
): status is ApplicationLifecycleStatus => status !== null && status in APPLICATION_LIFECYCLE_STATUS_TO_IMAGES;
